import type { ComponentPropsWithoutRef } from 'react';
import type { AvatarData } from '@/api/gen/_model/avatarData';
import { AvatarSpriteLayers } from '../avatarSpriteLayers';
import { AVATAR_BG_COLOR, type AvatarShape } from '../constants/avatar.constants';
import { AvatarFrame } from './AvatarFrame';

/** Sprite sheet: 432×256, 9 columns × 4 rows → each frame 48×64 */
const BASE_SPRITE_PIXEL_SIZE = 96;
const SPRITE_SHEET_WIDTH = 432;
const SPRITE_FRAME_WIDTH = 48;
const SPRITE_FRAME_HEIGHT = 64;
export const SpriteAvatar = ({
  avatarData,
  backgroundColor,
  spritePixelSize,
  shape = 'circle',
  className,
  style,
  ...props
}: ComponentPropsWithoutRef<'div'> & {
  avatarData: AvatarData;
  backgroundColor?: string;
  spritePixelSize: number;
  shape?: AvatarShape;
}) => {
  const spriteScale = spritePixelSize / BASE_SPRITE_PIXEL_SIZE;
  return <AvatarFrame shape={shape} backgroundColor={backgroundColor ?? AVATAR_BG_COLOR} className={className} style={{
    width: spritePixelSize,
    height: spritePixelSize,
    ...style
  }} {...props} data-sentry-element="AvatarFrame" data-sentry-component="SpriteAvatar" data-sentry-source-file="SpriteAvatar.tsx">
      <div className="relative shrink-0" style={{
      top: 15 * spriteScale,
      left: 1 * spriteScale,
      width: SPRITE_FRAME_WIDTH * 2 * spriteScale,
      height: SPRITE_FRAME_HEIGHT * 2 * spriteScale,
      imageRendering: 'pixelated'
    }}>
        <AvatarSpriteLayers avatarData={avatarData} layerStyle={{
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0 0',
        backgroundSize: `${SPRITE_SHEET_WIDTH * 2 * spriteScale}px auto`
      }} data-sentry-element="AvatarSpriteLayers" data-sentry-source-file="SpriteAvatar.tsx" />
      </div>
    </AvatarFrame>;
};